import React from 'react';
import { Link } from 'react-router-dom';

import Fetchable from '~/commons/components/util/Fetchable';

const Avatar = (props) => (
  <Fetchable req={{ url: '/api/users/self' }}>
    {({ mascot } = {}) => (
      <div {...props}>
        <div
          className="ratio ratio-1x1"
        >
          <div
            className={`
              border border-2 border-primary bg-white
              rounded-circle overflow-hidden
            `}
          >
            <div
              className="img-bg-contain"
              style={{
                backgroundImage: `url("${
                  mascot
                    ? `/uploads/${mascot.image[0].path}`
                    : '/assets/img/dragon-sil.png'
                }")`,
              }}
            />
          </div>
          <div>
            <Link
              to="/game/profile/mascot"
              className="position-absolute end-0 bottom-0"
            >
              <img
                alt="edit mascot"
                src="/assets/img/btn-edit.png"
                style={{ width: '2.6rem' }}
              />
            </Link>
          </div>
        </div>
      </div>
    )}
  </Fetchable>
);

export default Avatar;
